// Web環境では通知APIが未サポートのため、nullを返す
export const useLastNotificationResponseSafe = (): null => {
  return null
}
